import { TLang } from '@/utils/lang';
import ApiHelper, { ApiVersion } from '@/common/ApiHelper';
import { getLocalStorage, getSessonStorage, handlePara } from '@/utils/index';
import {
  moveQuery,
  cinemaQuery,
  seatQuery,
  sessionQuery,
  orderListQuery,
  detailQuery
} from '@/interface/req';
import { Toast, Modal } from 'antd-mobile';
import { Message } from 'zarm';
import { checkXcx } from '@/utils/checkXcx';
const api = new ApiHelper();
let basic_url = process.env.BASIC_URL;

// const movieUrl = {
// }
// const movieRequest = {
//   movieUrl,
//   /** 获取导航 */
//   GetUrlTime: () => {
//     return api.GetUrlTime();
//   },
// }
/**
 * 获取电影首页轮播图
 */
const getBannerList = function () {
  return api.Post(basic_url + '/home/slideshows', { type: 2, usingType: 3 }).then((res) => {
    // console.log('/home/slideshows',res)
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    } else {
      Toast.info(res.Message);
    }
  });
};
/**
 * 获取所有影片类型
 */
const getMovieType = function () {
  return api.Post(basic_url + '/movie/types').then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    } else {
      Toast.info(res.Message);
    }
  });
};
/**
 * 获取热映影片列表
 */
const getHotMovieList = function (x: moveQuery = { cityId: 145, pageIndex: 1, pageSize: 20 }) {
  return api.Post(basic_url + '/movie/hot/list', x).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    } else {
      Toast.info(res.Message);
    }
  });
};
/**
 * 获取即将上映影片列表
 */
const getSoonMovieList = function (x?: moveQuery) {
  return api.Post(basic_url + '/movie/soon/list', x).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    } else {
      Toast.info(res.Message);
    }
    // return res;
  });
};
/**
 * 获取票房影片列表
 */
const getMovieTop = function (limit: number = 5) {
  return api.Post(basic_url + '/home/boxoffice/movies', { limit }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    } else {
      Toast.info(res.Message);
    }
  });
};
/**
 * 获取影院区域数量、商圈数量
 */
const getCinemaDistrictCount = function (city) {
  return api.Post(basic_url + '/cinema/district/count', { cityId: city }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    } else {
      Toast.info(res.Message);
    }
  });
};
/**
 * 获取影院列表
 */
const getCinemaList = function (x?: cinemaQuery) {
  let loc = { location: { lat: null, lng: null } };
  let sloc = getSessonStorage('systemLoaction');
  if (sloc) {
    loc = JSON.parse(sloc);
  }
  const { location } = loc;
  return api
    .Post(basic_url + '/cinema/list', {
      ...x,
      longitude: location?.lng || '',
      latitude: location?.lat || ''
    })
    .then((res) => {
      // console.log('/cinema/list',res);
      if (res && res.Data && res.Status === 0) {
        return res.Data;
      } else {
        Toast.info(res.Message);
      }
    });
};

/**
 * 根据影片放映日期获取影院区域数量、商圈数量
 */
const getDistrictCounyByMovie = (movieId = '', showDate = '') =>
  // /cinema/district/bymovie/count
  // 使用 /cinema/district/count 代替一下(数据格式一样的)
  api
    .PostNew(
      basic_url + '/cinema/district/count',
      { movieId: movieId, showDate: showDate },
      { version: ApiVersion.v1 }
    )
    .then((res) => {
      if (res?.Status === 0) {
        return res.Data;
      }
      Toast.info(res?.Message || '未知错误');
    });

/**
 *  根据影片、放映日期获取影院列表
 */
const getCinemaListByMovie = (q: detailQuery) => {
  let loc = { location: { lng: null, lat: null } };
  let sloc = getSessonStorage('systemLoaction');
  if (sloc) {
    loc = JSON.parse(sloc);
  }
  const { location } = loc;

  return api
    .Post(basic_url + '/cinema/list/by_movie/h5', {
      ...q,
      longitude: location?.lng || '',
      latitude: location?.lat || ''
    })
    .then((res) => {
      if (res && res.Data && res.Status === 0) {
        return res.Data;
      }
      Toast.info(res.Message);
    });
};

/**
 *   获取影院详情
 */
const getCinema = (cinemaId = '') =>
  api.Post(basic_url + '/cinema/detail', { cinemaId }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });

/**
 *   根据影院、影片、放映日期获取场次列表
 */
const getSessionList = (q: sessionQuery = { pageIndex: 1, pageSize: 3 }) =>
  // console.log('getSessionList', q);
  api.Post(basic_url + '/session/list', q).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  })
  ;

/**
 * 获取座位图
 */
const getSeatList = (q: seatQuery, timeout?: any) =>
  api.Post(basic_url + '/session/selectseat', q, undefined, undefined, undefined, timeout).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    setTimeout(() => Toast.info(res.Message), 100);
  });

/**
 * 待支付订单信息
 * @param q
 * @returns
 */
const getUnPayOrderInfo = (q: any) =>
  api.Post(basic_url + '/order/unpaid/detail', q).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });

const getLockSeat = (q: any) =>
  api.Post(basic_url + '/lock_seat/v2', q).then(
    (res) =>
      // if(res && res.Data && res.Status ===0){
      res,
    // }
    // Toast.info(res.Message)
  );
/**
 * 获取订单列表
 */
const getOrderList = (q: orderListQuery = { pageIndex: 1, pageSize: 20 }) =>
  api.Post(basic_url + '/order/list', q).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });
/**
 * 取消订单
 */
const getOrderCancel = (s: string) =>
  api.Post(basic_url + '/order/cancel', { orderSn: s, sourceType: 8 }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });
/**
 * 获取确认订单详情
 */
const getOrderConfirmDetail = (s: any) =>
  api.Post(basic_url + '/order/confirm/detail', { ...s }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });
const getOrderConfirm = (s: string, mobile?: any) =>
  api.Post(basic_url + '/order/confirm/v2', { orderSn: s, phone: mobile }).then(
    (res) =>
      // if(res && res.Data && res.Status ===0){
      //   return res.Data
      // }
      // Toast.info(res.Message)
      res,
  );
const getOrderDetail = (s: string) =>
  api.Post(basic_url + '/order/detail', { orderSn: s }).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res.Message);
  });
const testDfSeatMap = () =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(textData.body);
    }, 1000);
  });

// 获取用户信息
const morequery = (params: any) =>
  api.Post(basic_url + '/user/info/external/morequery', handlePara(params)).then((res) => {
    if (res && res.Data && res.Status === 200) {
      return res.Data;
    }
    Toast.info(res?.Message);
  });

/**
* 获取短信验证码
*/
const getSmsHandle = (params: any) =>
  api.Post(basic_url + '/usercoord/sms/external/create', handlePara(params)).then((res) => res.Data);

/**
* 校验短信验证码
* 绑定手机号
*/
const valiSmsOrBindMobile = (url: string, params: any) =>
  api.Post(basic_url + url, handlePara(params)).then((res) => res.Data);

/**
 * 支付密码验证
 * */
const validatePaymentPwdHandle = (params: any) =>
  api.Post(basic_url + '/user/info/external/paypassword/validate', handlePara(params)).then((res) => res.Data);

/**
 * 设置更新支付密码
 */
const setPaymentPwdHandle = (params: any) =>
  api.Post(basic_url + '/user/info/external/paypassword/update', handlePara(params)).then((res) => {
    if (res && res.Data && res.Status === 200) {
      return res.Data;
    }
    Toast.info(res?.Message);
  });

const getCitysOffLine = (params) =>
  api.Post(basic_url + '/o2o/cinema/city/list', params).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }else if (res && res.Data && (res.Status === 223544||res.Status === 116001)) {
      window.df_sdk_common.location.replace('/newmovie/movieListdetail');
      return res.Data;
    }if (res && res.Data && res.Status === 223547) {
      return res.Data;
    } else if (res && res.Data && res.Status !== 223543&& res.Status !== 223545&& res.Status !== 223546){
      Toast.info(res?.Message);
    }
    return res.Data;
  });

const getCinemaOffLine = (params: any) =>
  api.Post(basic_url + '/o2o/cinema/list', params).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Toast.info(res?.Message);
  });

  // 电影订单详情跳转到申请退款页面
  const goToRefundApplyPage = (params: any) =>
    api.Post(basic_url + '/user/refund/apply/view', params).then((res) => {
      if (res && res.Data && res.Status === 0) {
        return res.Data;
      }
    // Toast.info(res?.Message);
    Modal.alert(TLang('申请失败', 'home', false, false, null), res?.Message, [{ text: TLang('我知道了', 'home', false, false, null), onPress: () => console.log('我知道了'), style: {border: '1px solid #3FA6FF', margin: '0px 20px 20px 20px', borderRadius: '4px', color:window?.dffl_global?.allCommonTheme?.globalThemeColor, borderColor:window?.dffl_global?.allCommonTheme?.globalThemeColor} }]);
  });
  // 非次卡申请退票
  const NonInferiorCardApplyRefund = (params: any) =>
  api.Post(basic_url + '/user/apply/refund', params).then((res) => {
    if (res && res.Data && res.Status === 0) {
      return res.Data;
    }
    Modal.alert(
      '',
      res?.Message,
      [{ text: TLang('我知道了', 'home', false, false, null),
      onPress: () => window.df_sdk_common.location.replace(window.location.origin + `/newmovie/order/status?orderSn=${params.orderSn}`),
      style: {border: '1px solid #3FA6FF', margin: '0px 20px 20px 20px', borderRadius: '4px', borderColor:window?.dffl_global?.allCommonTheme?.globalThemeColor} }]
    );
});
// 次卡&&有服务费申请退票
const inferiorCardApplyRefund = (params: any) =>
api.Post(basic_url + '/pay/service/charge', params).then((res) => {
  if (res && res.Data && res.Status === 0) {
    return res.Data;
  }
  Modal.alert(
    '',
    res?.Message,
    [{ text: TLang('我知道了', 'home', false, false, null),
    onPress: () => window.df_sdk_common.location.replace(window.location.origin + `/newmovie/order/status?orderSn=${params.orderSn}`),
    style: {border: '1px solid #3FA6FF', margin: '0px 20px 20px 20px', borderRadius: '4px', borderColor:window?.dffl_global?.allCommonTheme?.globalThemeColor} }]
  );
});
// 获取申请退款信息
const getApplyRefundDetail = (params: any) =>
api.Post(basic_url + '/apply/refund/result/view', params).then((res) => {
  if (res && res.Data && res.Status === 0) {
    return res.Data;
  }
Toast.info(res?.Message);
});

const findByUnionConfig = (params: any) => {
  const url = '/mallUnion/getConfig';
  return api.Post(basic_url + url, params).then((res) => {
    if (res) {
      return res.Data;
    }
  });
};

// 获取电影是否是黄牛限购
const getCattlePurchaseLimit = (params: any) =>
api.Post(basic_url + '/session/checkMovieVirtualScalper', params).then((res) => {
  if (res.Status === 1000000 || res.Status === 1000001){
    return;
  }
  if (res && res.Data && res.Status === 0) {
    return res.Data;
  }
  if (res?.Status == 222600) {
    return Toast.info(res?.Message);
  }
  Modal.alert(
    '',
    res?.Message,
    [{ text: TLang('我知道了', 'home', false, false, null),
    onPress: () => {},
    style: {border: '1px solid #3FA6FF', margin: '0px 20px 20px 20px', borderRadius: '4px', borderColor:window?.dffl_global?.allCommonTheme?.globalThemeColor} }]
  );
});

// 获取在线点餐
const getOnlineOrderingList = () =>
api.Post(basic_url + '/home/grid/list').then((res) => {
  if (res && res.Data && res.Status === 0) {
    return res.Data;
  }
  Toast.info(res?.Message);
});

// 获取音影列表
const getAudioAndVideoList = () =>
api.Post(basic_url + '/home/member/navigation').then((res) => {
  if (res && res.Data && res.Status === 0) {
    return res.Data;
  }
  Toast.info(res?.Message);
});


export default {
  getCinemaOffLine,
  getCitysOffLine,
  getMovieType,
  getBannerList,
  getHotMovieList,
  getSoonMovieList,
  getMovieTop,
  getCinemaDistrictCount,
  getCinemaList,
  getDistrictCounyByMovie,
  getCinemaListByMovie,
  getCinema,
  getSessionList,
  getSeatList,
  getLockSeat,
  getOrderConfirmDetail,
  getOrderList,
  getOrderConfirm,
  getOrderDetail,
  testDfSeatMap,
  getOrderCancel,
  morequery,
  getSmsHandle,
  valiSmsOrBindMobile,
  validatePaymentPwdHandle,
  setPaymentPwdHandle,
  goToRefundApplyPage,
  NonInferiorCardApplyRefund,
  inferiorCardApplyRefund,
  getApplyRefundDetail,
  findByUnionConfig,
  getCattlePurchaseLimit,
  getOnlineOrderingList,
  getUnPayOrderInfo,
  getAudioAndVideoList
};

const textData0 = {
  code: 0,
  msg: null,
  body: {
    cinemaName: '北京通州万达',
    movieName: '黄金兄弟（数字IMAX）',
    showDateTime: '2020-11-11 12:55:00',
    language: '国语',
    hallName: '1号厅VIP1B',
    dimensional: 'IMAX 3D',
    mobile: '13761121700',
    vendor: 20,
    vendorSessionId: 'C849202011110010010',
    vendorCinemaId: '849',
    maxPurchaseNum: 4,
    lastUpdateTime: '',
    vistaSource: 0,
    sectionPrices: [
      {
        id: '1',
        price: 3000,
        settlePrice: 3000,
        dfCostPrice: 2830,
        hallFee: 0,
        serviceFee: 0,
        marketingCode: ''
      }
    ],
    existLoveSeat: true,
    regular: true,
    priceCode: 'CP0000001924',
    priceName: '东方福利-网购票',
    refVendor: null,
    floors: null,
    seats: [
      {
        seatX: 1,
        seatY: 1,
        seatDesc: '1排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 1,
        seatDesc: '1排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 1,
        seatDesc: '1排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 1,
        seatDesc: '1排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 1,
        seatDesc: '1排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 1,
        seatDesc: '1排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 1,
        seatDesc: '1排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 1,
        seatDesc: '1排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 1,
        seatDesc: '1排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 1,
        seatDesc: '1排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 1,
        seatDesc: '1排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 1,
        seatDesc: '1排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 1,
        seatDesc: '1排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 1,
        seatDesc: '1排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 1,
        seatDesc: '1排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 1,
        seatDesc: '1排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 1,
        seatDesc: '1排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-1-17',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 2,
        seatDesc: '2排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 2,
        seatDesc: '2排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 2,
        seatDesc: '2排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 2,
        seatDesc: '2排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 2,
        seatDesc: '2排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 2,
        seatDesc: '2排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 2,
        seatDesc: '2排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 2,
        seatDesc: '2排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 2,
        seatDesc: '2排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 2,
        seatDesc: '2排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 2,
        seatDesc: '2排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 2,
        seatDesc: '2排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 2,
        seatDesc: '2排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 2,
        seatDesc: '2排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 2,
        seatDesc: '2排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 2,
        seatDesc: '2排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 2,
        seatDesc: '2排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-2-17',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 3,
        seatDesc: '3排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 3,
        seatDesc: '3排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 3,
        seatDesc: '3排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 3,
        seatDesc: '3排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 3,
        seatDesc: '3排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 3,
        seatDesc: '3排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 3,
        seatDesc: '3排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 3,
        seatDesc: '3排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 3,
        seatDesc: '3排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 3,
        seatDesc: '3排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 3,
        seatDesc: '3排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 3,
        seatDesc: '3排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 3,
        seatDesc: '3排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 3,
        seatDesc: '3排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 3,
        seatDesc: '3排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 3,
        seatDesc: '3排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 3,
        seatDesc: '3排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-3-17',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 4,
        seatDesc: '4排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 4,
        seatDesc: '4排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 4,
        seatDesc: '4排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 4,
        seatDesc: '4排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 4,
        seatDesc: '4排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 4,
        seatDesc: '4排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 4,
        seatDesc: '4排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 4,
        seatDesc: '4排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 4,
        seatDesc: '4排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 4,
        seatDesc: '4排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 4,
        seatDesc: '4排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 4,
        seatDesc: '4排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 4,
        seatDesc: '4排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 4,
        seatDesc: '4排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 4,
        seatDesc: '4排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 4,
        seatDesc: '4排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 4,
        seatDesc: '4排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-4-17',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 5,
        seatDesc: '5排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 5,
        seatDesc: '5排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 5,
        seatDesc: '5排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 5,
        seatDesc: '5排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 5,
        seatDesc: '5排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 5,
        seatDesc: '5排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 5,
        seatDesc: '5排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 5,
        seatDesc: '5排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 5,
        seatDesc: '5排9座',
        seatType: 4,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 5,
        seatDesc: '5排10座',
        seatType: 5,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 5,
        seatDesc: '5排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 5,
        seatDesc: '5排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 5,
        seatDesc: '5排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 5,
        seatDesc: '5排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 5,
        seatDesc: '5排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 5,
        seatDesc: '5排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 5,
        seatDesc: '5排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-5-17',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 6,
        seatDesc: '6排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 6,
        seatDesc: '6排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 6,
        seatDesc: '6排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 6,
        seatDesc: '6排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 6,
        seatDesc: '6排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 6,
        seatDesc: '6排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 6,
        seatDesc: '6排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-7',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 6,
        seatDesc: '6排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-8',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 6,
        seatDesc: '6排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 6,
        seatDesc: '6排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 6,
        seatDesc: '6排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 6,
        seatDesc: '6排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 6,
        seatDesc: '6排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 6,
        seatDesc: '6排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 6,
        seatDesc: '6排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 6,
        seatDesc: '6排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 6,
        seatDesc: '6排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-6-17',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 7,
        seatDesc: '7排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 7,
        seatDesc: '7排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 7,
        seatDesc: '7排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 7,
        seatDesc: '7排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 7,
        seatDesc: '7排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-5',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 7,
        seatDesc: '7排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-6',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 7,
        seatDesc: '7排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-7',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 7,
        seatDesc: '7排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-8',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 7,
        seatDesc: '7排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-9',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 7,
        seatDesc: '7排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 7,
        seatDesc: '7排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 7,
        seatDesc: '7排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 7,
        seatDesc: '7排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 7,
        seatDesc: '7排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 7,
        seatDesc: '7排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 7,
        seatDesc: '7排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 7,
        seatDesc: '7排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-7-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 8,
        seatDesc: '8排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 8,
        seatDesc: '8排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 8,
        seatDesc: '8排3座',
        seatType: 4,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-3',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 8,
        seatDesc: '8排4座',
        seatType: 5,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-4',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 8,
        seatDesc: '8排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 8,
        seatDesc: '8排6座',
        seatType: 4,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 8,
        seatDesc: '8排7座',
        seatType: 5,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 8,
        seatDesc: '8排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 8,
        seatDesc: '8排9座',
        seatType: 4,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 8,
        seatDesc: '8排10座',
        seatType: 5,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 8,
        seatDesc: '8排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 8,
        seatDesc: '8排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 8,
        seatDesc: '8排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 8,
        seatDesc: '8排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 8,
        seatDesc: '8排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 8,
        seatDesc: '8排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 8,
        seatDesc: '8排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-8-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 9,
        seatDesc: '9排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 9,
        seatDesc: '9排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 9,
        seatDesc: '9排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 9,
        seatDesc: '9排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 9,
        seatDesc: '9排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 9,
        seatDesc: '9排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 9,
        seatDesc: '9排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 9,
        seatDesc: '9排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 9,
        seatDesc: '9排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 9,
        seatDesc: '9排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 9,
        seatDesc: '9排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 9,
        seatDesc: '9排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 9,
        seatDesc: '9排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 9,
        seatDesc: '9排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 9,
        seatDesc: '9排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 9,
        seatDesc: '9排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 9,
        seatDesc: '9排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-9-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 10,
        seatDesc: '10排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 10,
        seatDesc: '10排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 10,
        seatDesc: '10排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 10,
        seatDesc: '10排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 10,
        seatDesc: '10排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 10,
        seatDesc: '10排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 10,
        seatDesc: '10排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 10,
        seatDesc: '10排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 10,
        seatDesc: '10排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 10,
        seatDesc: '10排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 10,
        seatDesc: '10排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 10,
        seatDesc: '10排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 10,
        seatDesc: '10排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 10,
        seatDesc: '10排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 10,
        seatDesc: '10排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 10,
        seatDesc: '10排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 10,
        seatDesc: '10排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-10-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 11,
        seatDesc: '11排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 11,
        seatDesc: '11排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 11,
        seatDesc: '11排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 11,
        seatDesc: '11排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 11,
        seatDesc: '11排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 11,
        seatDesc: '11排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 11,
        seatDesc: '11排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 11,
        seatDesc: '11排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 11,
        seatDesc: '11排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 11,
        seatDesc: '11排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 11,
        seatDesc: '11排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 11,
        seatDesc: '11排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 11,
        seatDesc: '11排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 11,
        seatDesc: '11排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 11,
        seatDesc: '11排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 11,
        seatDesc: '11排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 11,
        seatDesc: '11排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-11-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 12,
        seatDesc: '12排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 12,
        seatDesc: '12排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 12,
        seatDesc: '12排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 12,
        seatDesc: '12排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 12,
        seatDesc: '12排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 12,
        seatDesc: '12排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 12,
        seatDesc: '12排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 12,
        seatDesc: '12排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 12,
        seatDesc: '12排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 12,
        seatDesc: '12排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 12,
        seatDesc: '12排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 12,
        seatDesc: '12排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 12,
        seatDesc: '12排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 12,
        seatDesc: '12排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 12,
        seatDesc: '12排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 12,
        seatDesc: '12排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 12,
        seatDesc: '12排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-12-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 13,
        seatDesc: '13排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-1',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 13,
        seatDesc: '13排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-2',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 13,
        seatDesc: '13排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-3',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 13,
        seatDesc: '13排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-4',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 13,
        seatDesc: '13排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-5',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 13,
        seatDesc: '13排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-6',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 13,
        seatDesc: '13排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-7',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 8,
        seatY: 13,
        seatDesc: '13排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-8',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 9,
        seatY: 13,
        seatDesc: '13排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-9',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 10,
        seatY: 13,
        seatDesc: '13排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-10',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 11,
        seatY: 13,
        seatDesc: '13排11座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-11',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 12,
        seatY: 13,
        seatDesc: '13排12座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-12',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 13,
        seatY: 13,
        seatDesc: '13排13座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-13',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 14,
        seatY: 13,
        seatDesc: '13排14座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-14',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 15,
        seatY: 13,
        seatDesc: '13排15座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-15',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 16,
        seatY: 13,
        seatDesc: '13排16座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-16',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 17,
        seatY: 13,
        seatDesc: '13排17座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '1-13-17',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      }
    ],
    movieCode: '001307022018',
    cinemaCode: '11080581',
    sessionKey: null,
    refPrice: null,
    optimumSelectStrategy: ''
  }
};

const textData = {
  code: 1,
  message: null,
  body: {
    regular: false,
    floors: [],
    maxPurchaseNum: 5,
    sectionPrices: [
      {
        id: '1',
        price: 5830,
        settlePrice: 5300,
        dfCostPrice: 5088
      },
      {
        id: '538',
        price: 3830,
        settlePrice: 5300,
        dfCostPrice: 5088
      }
    ],
    seats: [
      {
        seatX: 120,
        seatY: 30,
        seatDesc: '1排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4218',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 30,
        seatDesc: '1排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4219',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 30,
        seatDesc: '1排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4220',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 30,
        seatDesc: '1排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4221',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 240,
        seatY: 30,
        seatDesc: '1排5座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4222',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 270,
        seatY: 30,
        seatDesc: '1排6座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4223',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 30,
        seatDesc: '1排7座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4224',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 30,
        seatDesc: '1排8座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4225',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 30,
        seatDesc: '1排9座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4226',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 30,
        seatDesc: '1排10座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4227',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 30,
        seatDesc: '1排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4228',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 30,
        seatDesc: '1排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4229',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 30,
        seatDesc: '1排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4230',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 30,
        seatDesc: '1排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4231',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 30,
        seatDesc: '1排15座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4232',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 30,
        seatDesc: '1排16座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4233',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 60,
        seatDesc: '2排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4237',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 60,
        seatDesc: '2排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4238',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 60,
        seatDesc: '2排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4239',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 60,
        seatDesc: '2排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4240',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 240,
        seatY: 60,
        seatDesc: '2排5座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4241',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 270,
        seatY: 60,
        seatDesc: '2排6座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4242',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 60,
        seatDesc: '2排7座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4243',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 60,
        seatDesc: '2排8座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4244',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 60,
        seatDesc: '2排9座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4245',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 60,
        seatDesc: '2排10座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4246',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 60,
        seatDesc: '2排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4247',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 60,
        seatDesc: '2排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4248',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 60,
        seatDesc: '2排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4249',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 60,
        seatDesc: '2排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4250',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 60,
        seatDesc: '2排15座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4251',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 60,
        seatDesc: '2排16座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4252',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 90,
        seatDesc: '3排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4256',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 90,
        seatDesc: '3排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4257',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 90,
        seatDesc: '3排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4258',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 90,
        seatDesc: '3排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4259',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 240,
        seatY: 90,
        seatDesc: '3排5座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4260',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 270,
        seatY: 90,
        seatDesc: '3排6座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4261',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 90,
        seatDesc: '3排7座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4262',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 90,
        seatDesc: '3排8座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4263',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 90,
        seatDesc: '3排9座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4264',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 90,
        seatDesc: '3排10座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4265',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 90,
        seatDesc: '3排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4266',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 90,
        seatDesc: '3排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4267',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 90,
        seatDesc: '3排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4268',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 90,
        seatDesc: '3排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4269',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 90,
        seatDesc: '3排15座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4270',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 90,
        seatDesc: '3排16座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4271',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 150,
        seatDesc: '4排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4294',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 150,
        seatDesc: '4排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4295',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 150,
        seatDesc: '4排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4296',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 150,
        seatDesc: '4排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4297',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 150,
        seatDesc: '4排5座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4300',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 150,
        seatDesc: '4排6座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4301',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 150,
        seatDesc: '4排7座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4302',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 150,
        seatDesc: '4排8座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4303',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 150,
        seatDesc: '4排9座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4304',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 150,
        seatDesc: '4排10座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4305',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 150,
        seatDesc: '4排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4306',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 150,
        seatDesc: '4排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4307',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 150,
        seatDesc: '4排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4308',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 150,
        seatDesc: '4排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4309',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 180,
        seatDesc: '5排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4313',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 180,
        seatDesc: '5排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4314',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 180,
        seatDesc: '5排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4315',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 180,
        seatDesc: '5排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4316',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 180,
        seatDesc: '5排5座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4319',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 180,
        seatDesc: '5排6座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4320',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 180,
        seatDesc: '5排7座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4321',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 180,
        seatDesc: '5排8座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4322',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 180,
        seatDesc: '5排9座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4323',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 180,
        seatDesc: '5排10座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4324',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 180,
        seatDesc: '5排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4325',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 180,
        seatDesc: '5排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4326',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 180,
        seatDesc: '5排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4327',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 180,
        seatDesc: '5排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4328',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 210,
        seatDesc: '6排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4332',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 210,
        seatDesc: '6排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4333',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 210,
        seatDesc: '6排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4334',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 210,
        seatDesc: '6排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4335',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 210,
        seatDesc: '6排5座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4338',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 210,
        seatDesc: '6排6座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4339',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 210,
        seatDesc: '6排7座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4340',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 210,
        seatDesc: '6排8座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4341',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 210,
        seatDesc: '6排9座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4342',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 210,
        seatDesc: '6排10座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4343',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 210,
        seatDesc: '6排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4344',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 210,
        seatDesc: '6排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4345',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 210,
        seatDesc: '6排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4346',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 210,
        seatDesc: '6排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4347',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 240,
        seatDesc: '7排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4351',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 240,
        seatDesc: '7排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4352',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 240,
        seatDesc: '7排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4353',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 240,
        seatDesc: '7排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4354',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 240,
        seatDesc: '7排5座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4357',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 240,
        seatDesc: '7排6座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4358',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 240,
        seatDesc: '7排7座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4359',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 240,
        seatDesc: '7排8座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4360',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 240,
        seatDesc: '7排9座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4361',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 240,
        seatDesc: '7排10座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4362',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 240,
        seatDesc: '7排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4363',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 240,
        seatDesc: '7排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4364',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 240,
        seatDesc: '7排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4365',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 240,
        seatDesc: '7排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4366',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 30,
        seatY: 270,
        seatDesc: '8排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4367',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 60,
        seatY: 270,
        seatDesc: '8排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4368',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 90,
        seatY: 270,
        seatDesc: '8排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4369',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 270,
        seatDesc: '8排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4370',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 270,
        seatDesc: '8排5座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4371',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 270,
        seatDesc: '8排6座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4372',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 270,
        seatDesc: '8排7座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4373',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 270,
        seatDesc: '8排8座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4376',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 270,
        seatDesc: '8排9座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4377',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 270,
        seatDesc: '8排10座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4378',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 270,
        seatDesc: '8排11座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4379',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 270,
        seatDesc: '8排12座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4380',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 270,
        seatDesc: '8排13座',
        seatType: 2,
        sectionId: '538',
        vendorSeatId: '4381',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 270,
        seatDesc: '8排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4382',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 270,
        seatDesc: '8排15座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4383',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 270,
        seatDesc: '8排16座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4384',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 270,
        seatDesc: '8排17座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4385',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 30,
        seatY: 300,
        seatDesc: '9排1座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4386',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 60,
        seatY: 300,
        seatDesc: '9排2座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4387',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 90,
        seatY: 300,
        seatDesc: '9排3座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4388',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 120,
        seatY: 300,
        seatDesc: '9排4座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4389',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 150,
        seatY: 300,
        seatDesc: '9排5座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4390',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 180,
        seatY: 300,
        seatDesc: '9排6座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4391',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 210,
        seatY: 300,
        seatDesc: '9排7座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4392',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 240,
        seatY: 300,
        seatDesc: '9排8座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4393',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 270,
        seatY: 300,
        seatDesc: '9排9座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4394',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 300,
        seatY: 300,
        seatDesc: '9排10座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4395',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 330,
        seatY: 300,
        seatDesc: '9排11座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4396',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 360,
        seatY: 300,
        seatDesc: '9排12座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4397',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 390,
        seatY: 300,
        seatDesc: '9排13座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4398',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 420,
        seatY: 300,
        seatDesc: '9排14座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4399',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 450,
        seatY: 300,
        seatDesc: '9排15座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4400',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 480,
        seatY: 300,
        seatDesc: '9排16座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4401',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 510,
        seatY: 300,
        seatDesc: '9排17座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4402',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 540,
        seatY: 300,
        seatDesc: '9排18座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4403',
        status: 1,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      },
      {
        seatX: 570,
        seatY: 300,
        seatDesc: '9排19座',
        seatType: 2,
        sectionId: '1',
        vendorSeatId: '4404',
        status: 2,
        priceCode: null,
        priceName: null,
        hallFee: null,
        cinemaAllowance: null,
        floorId: ''
      }
    ]
  },
  success: true
};
const textData2 = {
  code: 1,
  message: null,
  body: {
    regular: true,
    floors: [],
    maxPurchaseNum: 6,
    sectionPrices: [
      {
        id: null,
        price: 4070,
        settlePrice: 3700,
        dfCostPrice: 3552,
        hallFee: 0,
        serviceFee: 400,
        marketingCode: null
      }
    ],
    seats: [
      {
        seatX: 1,
        seatY: 1,
        seatDesc: '1排15座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 1,
        seatDesc: '1排14座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 1,
        seatDesc: '1排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 1,
        seatDesc: '1排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-4',
        status: 2,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 1,
        seatDesc: '1排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-5',
        status: 2,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 1,
        seatDesc: '1排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-6',
        status: 2,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 1,
        seatDesc: '1排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-7',
        status: 2,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 1,
        seatDesc: '1排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-8',
        status: 2,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 1,
        seatDesc: '1排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-1-9',
        status: 2,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 2,
        seatDesc: '2排14座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 2,
        seatDesc: '2排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 2,
        seatDesc: '2排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 2,
        seatDesc: '2排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-4',
        status: 2,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 2,
        seatDesc: '2排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-5',
        status: 2,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 2,
        seatDesc: '2排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-6',
        status: 2,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 2,
        seatDesc: '2排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-7',
        status: 2,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 2,
        seatDesc: '2排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-8',
        status: 2,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 2,
        seatDesc: '2排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-2-9',
        status: 2,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 3,
        seatDesc: '3排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 3,
        seatDesc: '3排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 3,
        seatDesc: '3排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 3,
        seatDesc: '3排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-4',
        status: 1,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 3,
        seatDesc: '3排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-5',
        status: 1,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 3,
        seatDesc: '3排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-6',
        status: 1,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 3,
        seatDesc: '3排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-7',
        status: 1,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 3,
        seatDesc: '3排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-8',
        status: 1,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 3,
        seatDesc: '3排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-3-9',
        status: 1,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 4,
        seatDesc: '4排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 4,
        seatDesc: '4排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 4,
        seatDesc: '4排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 4,
        seatDesc: '4排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-4',
        status: 1,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 4,
        seatDesc: '4排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-5',
        status: 1,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 4,
        seatDesc: '4排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-6',
        status: 1,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 4,
        seatDesc: '4排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-7',
        status: 1,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 4,
        seatDesc: '4排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-8',
        status: 1,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 4,
        seatDesc: '4排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-4-9',
        status: 1,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 5,
        seatDesc: '5排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 5,
        seatDesc: '5排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 5,
        seatDesc: '5排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 5,
        seatDesc: '5排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-4',
        status: 1,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 5,
        seatDesc: '5排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-5',
        status: 1,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 5,
        seatDesc: '5排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-6',
        status: 1,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 5,
        seatDesc: '5排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-7',
        status: 1,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 5,
        seatDesc: '5排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-8',
        status: 1,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 5,
        seatDesc: '5排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-5-9',
        status: 1,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 6,
        seatDesc: '6排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 6,
        seatDesc: '6排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 6,
        seatDesc: '6排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 6,
        seatDesc: '6排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-4',
        status: 1,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 6,
        seatDesc: '6排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-5',
        status: 1,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 6,
        seatDesc: '6排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-6',
        status: 1,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 6,
        seatDesc: '6排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-7',
        status: 1,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 6,
        seatDesc: '6排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-8',
        status: 1,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 6,
        seatDesc: '6排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-6-9',
        status: 1,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 7,
        seatDesc: '7排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 7,
        seatDesc: '7排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 7,
        seatDesc: '7排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-3',
        status: 2,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 7,
        seatDesc: '7排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-4',
        status: 1,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 7,
        seatDesc: '7排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-5',
        status: 1,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 7,
        seatDesc: '7排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-6',
        status: 1,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 7,
        seatDesc: '7排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-7',
        status: 1,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 7,
        seatDesc: '7排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-8',
        status: 2,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 7,
        seatDesc: '7排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-7-9',
        status: 2,
        floorId: ''
      },
      {
        seatX: 1,
        seatY: 8,
        seatDesc: '8排18座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-1',
        status: 2,
        floorId: ''
      },
      {
        seatX: 2,
        seatY: 8,
        seatDesc: '8排17座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-2',
        status: 2,
        floorId: ''
      },
      {
        seatX: 3,
        seatY: 8,
        seatDesc: '8排16座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-3',
        status: 1,
        floorId: ''
      },
      {
        seatX: 4,
        seatY: 8,
        seatDesc: '8排15座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-4',
        status: 1,
        floorId: ''
      },
      {
        seatX: 5,
        seatY: 8,
        seatDesc: '8排14座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-5',
        status: 1,
        floorId: ''
      },
      {
        seatX: 6,
        seatY: 8,
        seatDesc: '8排13座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-6',
        status: 1,
        floorId: ''
      },
      {
        seatX: 7,
        seatY: 8,
        seatDesc: '8排12座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-7',
        status: 1,
        floorId: ''
      },
      {
        seatX: 8,
        seatY: 8,
        seatDesc: '8排11座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-8',
        status: 1,
        floorId: ''
      },
      {
        seatX: 9,
        seatY: 8,
        seatDesc: '8排10座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '000000024913-8-9',
        status: 1,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 1,
        seatDesc: '1排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-1-10',
        status: 2,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 1,
        seatDesc: '1排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-1-11',
        status: 2,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 1,
        seatDesc: '1排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-1-12',
        status: 2,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 1,
        seatDesc: '1排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-1-13',
        status: 2,
        floorId: ''
      },
      {
        seatX: 14,
        seatY: 1,
        seatDesc: '1排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-1-14',
        status: 2,
        floorId: ''
      },
      {
        seatX: 15,
        seatY: 1,
        seatDesc: '1排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-1-15',
        status: 2,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 2,
        seatDesc: '2排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-2-10',
        status: 2,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 2,
        seatDesc: '2排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-2-11',
        status: 2,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 2,
        seatDesc: '2排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-2-12',
        status: 2,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 2,
        seatDesc: '2排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-2-13',
        status: 2,
        floorId: ''
      },
      {
        seatX: 14,
        seatY: 2,
        seatDesc: '2排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-2-14',
        status: 2,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 3,
        seatDesc: '3排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-3-10',
        status: 1,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 3,
        seatDesc: '3排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-3-11',
        status: 1,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 3,
        seatDesc: '3排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-3-12',
        status: 1,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 3,
        seatDesc: '3排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-3-13',
        status: 1,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 4,
        seatDesc: '4排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-4-10',
        status: 1,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 4,
        seatDesc: '4排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-4-11',
        status: 1,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 4,
        seatDesc: '4排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-4-12',
        status: 1,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 4,
        seatDesc: '4排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-4-13',
        status: 1,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 5,
        seatDesc: '5排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-5-10',
        status: 1,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 5,
        seatDesc: '5排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-5-11',
        status: 1,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 5,
        seatDesc: '5排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-5-12',
        status: 1,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 5,
        seatDesc: '5排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-5-13',
        status: 1,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 6,
        seatDesc: '6排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-6-10',
        status: 1,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 6,
        seatDesc: '6排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-6-11',
        status: 1,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 6,
        seatDesc: '6排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-6-12',
        status: 1,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 6,
        seatDesc: '6排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-6-13',
        status: 1,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 7,
        seatDesc: '7排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-7-10',
        status: 2,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 7,
        seatDesc: '7排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-7-11',
        status: 2,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 7,
        seatDesc: '7排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-7-12',
        status: 1,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 7,
        seatDesc: '7排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-7-13',
        status: 1,
        floorId: ''
      },
      {
        seatX: 10,
        seatY: 8,
        seatDesc: '8排9座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-10',
        status: 1,
        floorId: ''
      },
      {
        seatX: 11,
        seatY: 8,
        seatDesc: '8排8座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-11',
        status: 1,
        floorId: ''
      },
      {
        seatX: 12,
        seatY: 8,
        seatDesc: '8排7座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-12',
        status: 1,
        floorId: ''
      },
      {
        seatX: 13,
        seatY: 8,
        seatDesc: '8排6座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-13',
        status: 1,
        floorId: ''
      },
      {
        seatX: 14,
        seatY: 8,
        seatDesc: '8排5座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-14',
        status: 1,
        floorId: ''
      },
      {
        seatX: 15,
        seatY: 8,
        seatDesc: '8排4座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-15',
        status: 1,
        floorId: ''
      },
      {
        seatX: 16,
        seatY: 8,
        seatDesc: '8排3座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-16',
        status: 2,
        floorId: ''
      },
      {
        seatX: 17,
        seatY: 8,
        seatDesc: '8排2座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-17',
        status: 2,
        floorId: ''
      },
      {
        seatX: 18,
        seatY: 8,
        seatDesc: '8排1座',
        seatType: 2,
        sectionId: '0',
        vendorSeatId: '00000024913-8-18',
        status: 2,
        floorId: ''
      }
    ],
    priceCode: null,
    priceName: null,
    hallFee: null
  },
  success: true
};
const textData3 = {
  code: 0,
  msg: null,
  body: {
    cinemaName: '丰润金缘数字影城',
    movieName: '夺冠',
    showDateTime: '2020-09-29 19:40:00',
    language: '测试',
    hallName: '3号厅',
    dimensional: '4D',
    mobile: '13111111113',
    vendor: 9,
    vendorSessionId: '782504867',
    vendorCinemaId: '10100',
    maxPurchaseNum: 5,
    lastUpdateTime: '',
    vistaSource: 0,
    sectionPrices: [
      {
        id: '',
        price: 3520,
        settlePrice: 3200,
        dfCostPrice: 3069,
        hallFee: 0,
        serviceFee: 400,
        marketingCode: null
      }
    ],
    existLoveSeat: false,
    regular: false,
    priceCode: '',
    priceName: '',
    refVendor: null,
    floors: null,
    seats: [
      {
        seatX: 360,
        seatY: 30,
        seatDesc: '1排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 30,
        seatDesc: '1排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 30,
        seatDesc: '1排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 30,
        seatDesc: '1排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 30,
        seatDesc: '1排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 210,
        seatY: 30,
        seatDesc: '1排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 180,
        seatY: 30,
        seatDesc: '1排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#07',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 30,
        seatDesc: '1排8列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#08',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 30,
        seatDesc: '1排9列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#09',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 30,
        seatDesc: '1排10列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 30,
        seatDesc: '1排11列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#01#11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 60,
        seatDesc: '2排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 60,
        seatDesc: '2排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 60,
        seatDesc: '2排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 60,
        seatDesc: '2排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 60,
        seatDesc: '2排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 210,
        seatY: 60,
        seatDesc: '2排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 180,
        seatY: 60,
        seatDesc: '2排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#07',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 60,
        seatDesc: '2排8列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#08',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 60,
        seatDesc: '2排9列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#09',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 60,
        seatDesc: '2排10列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 60,
        seatDesc: '2排11列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#02#11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 90,
        seatDesc: '3排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 90,
        seatDesc: '3排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 90,
        seatDesc: '3排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 90,
        seatDesc: '3排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 90,
        seatDesc: '3排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 210,
        seatY: 90,
        seatDesc: '3排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 180,
        seatY: 90,
        seatDesc: '3排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#07',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 90,
        seatDesc: '3排8列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#08',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 90,
        seatDesc: '3排9列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#09',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 90,
        seatDesc: '3排10列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 90,
        seatDesc: '3排11列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#03#11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 120,
        seatDesc: '4排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 120,
        seatDesc: '4排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 120,
        seatDesc: '4排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 120,
        seatDesc: '4排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 120,
        seatDesc: '4排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 210,
        seatY: 120,
        seatDesc: '4排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 180,
        seatY: 120,
        seatDesc: '4排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#07',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 120,
        seatDesc: '4排8列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#08',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 120,
        seatDesc: '4排9列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#09',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 120,
        seatDesc: '4排10列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 120,
        seatDesc: '4排11列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#04#11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 150,
        seatDesc: '5排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 150,
        seatDesc: '5排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 150,
        seatDesc: '5排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#03',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 150,
        seatDesc: '5排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#04',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 150,
        seatDesc: '5排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 210,
        seatY: 150,
        seatDesc: '5排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 180,
        seatY: 150,
        seatDesc: '5排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#07',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 150,
        seatDesc: '5排8列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#08',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 150,
        seatDesc: '5排9列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#09',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 150,
        seatDesc: '5排10列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 150,
        seatDesc: '5排11列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#05#11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 180,
        seatDesc: '6排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 180,
        seatDesc: '6排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 180,
        seatDesc: '6排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 180,
        seatDesc: '6排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 180,
        seatDesc: '6排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 210,
        seatY: 180,
        seatDesc: '6排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 180,
        seatY: 180,
        seatDesc: '6排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#07',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 180,
        seatDesc: '6排8列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#08',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 180,
        seatDesc: '6排9列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#09',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 180,
        seatDesc: '6排10列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#10',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 180,
        seatDesc: '6排11列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#06#11',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 240,
        seatDesc: '7排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#01',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 240,
        seatDesc: '7排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 240,
        seatDesc: '7排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 240,
        seatDesc: '7排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 240,
        seatDesc: '7排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#05',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 240,
        seatDesc: '7排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 240,
        seatDesc: '7排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#07#07',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 270,
        seatDesc: '8排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#01',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 270,
        seatDesc: '8排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 270,
        seatDesc: '8排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 270,
        seatDesc: '8排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 270,
        seatDesc: '8排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#05',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 270,
        seatDesc: '8排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 270,
        seatDesc: '8排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#08#07',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 330,
        seatY: 300,
        seatDesc: '9排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#01',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 300,
        seatY: 300,
        seatDesc: '9排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#02',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 270,
        seatY: 300,
        seatDesc: '9排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#03',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 240,
        seatY: 300,
        seatDesc: '9排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#04',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 150,
        seatY: 300,
        seatDesc: '9排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#05',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 300,
        seatDesc: '9排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#06',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 300,
        seatDesc: '9排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#09#07',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 330,
        seatDesc: '10排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#10#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 420,
        seatY: 360,
        seatDesc: '11排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#11#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 390,
        seatY: 360,
        seatDesc: '11排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#11#02',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 360,
        seatDesc: '11排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#11#03',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 360,
        seatDesc: '11排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#11#04',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 360,
        seatDesc: '11排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#11#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 30,
        seatY: 360,
        seatDesc: '11排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#11#06',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 420,
        seatY: 390,
        seatDesc: '12排1列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#01',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 390,
        seatY: 390,
        seatDesc: '12排2列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#02',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 360,
        seatY: 390,
        seatDesc: '12排3列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#03',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 120,
        seatY: 390,
        seatDesc: '12排4列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#04',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 90,
        seatY: 390,
        seatDesc: '12排5列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#05',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 60,
        seatY: 390,
        seatDesc: '12排6列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#06',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 30,
        seatY: 390,
        seatDesc: '12排7列',
        seatType: 2,
        sectionId: '0',
        floorId: '',
        vendorSeatId: '3405100103#12#07',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      }
    ]
  }
};
const textData4 = {
  code: 0,
  msg: null,
  body: {
    cinemaName: '比高电影城（浦东机场店）--鼎新专用本地影院数据测试',
    movieName: '82号古宅---鼎新本地专用测试数据',
    showDateTime: '2020-10-20 22:20:00',
    language: '国语',
    hallName: '3号厅',
    dimensional: '2D',
    mobile: '13599134582',
    vendor: 10,
    vendorSessionId: '128642001',
    vendorCinemaId: '20004010',
    maxPurchaseNum: 3,
    lastUpdateTime: '2020-10-18 22:33:31',
    vistaSource: null,
    sectionPrices: [
      {
        id: '',
        price: 4060,
        settlePrice: 4030,
        dfCostPrice: 3913,
        hallFee: 0,
        serviceFee: 0,
        marketingCode: null
      }
    ],
    existLoveSeat: false,
    regular: true,
    priceCode: '',
    priceName: '',
    refVendor: null,
    floors: null,
    seats: [
      {
        seatX: 1,
        seatY: 1,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '141',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 2,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '142',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 3,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '143',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 4,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '144',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 5,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '145',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 6,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '146',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 7,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '147',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 8,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '148',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 9,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '149',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 1,
        seatY: 10,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '150',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 1,
        seatDesc: '1排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '151',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 2,
        seatDesc: '1排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '152',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 3,
        seatDesc: '1排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '153',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 4,
        seatDesc: '1排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '154',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 5,
        seatDesc: '1排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '155',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 6,
        seatDesc: '1排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '156',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 7,
        seatDesc: '1排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '157',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 8,
        seatDesc: '1排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '158',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 9,
        seatDesc: '1排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '159',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 2,
        seatY: 10,
        seatDesc: '1排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '160',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 1,
        seatDesc: '2排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '161',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 2,
        seatDesc: '2排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '162',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 3,
        seatDesc: '2排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '163',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 4,
        seatDesc: '2排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '164',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 5,
        seatDesc: '2排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '165',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 6,
        seatDesc: '2排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '166',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 7,
        seatDesc: '2排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '167',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 8,
        seatDesc: '2排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '168',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 9,
        seatDesc: '2排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '169',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 3,
        seatY: 10,
        seatDesc: '2排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '170',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 1,
        seatDesc: '3排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '171',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 2,
        seatDesc: '3排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '172',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 3,
        seatDesc: '3排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '173',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 4,
        seatDesc: '3排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '174',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 5,
        seatDesc: '3排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '175',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 6,
        seatDesc: '3排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '176',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 7,
        seatDesc: '3排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '177',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 8,
        seatDesc: '3排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '178',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 9,
        seatDesc: '3排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '179',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 4,
        seatY: 10,
        seatDesc: '3排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '180',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 1,
        seatDesc: '4排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '181',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 2,
        seatDesc: '4排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '182',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 3,
        seatDesc: '4排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '183',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 4,
        seatDesc: '4排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '184',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 5,
        seatDesc: '4排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '185',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 6,
        seatDesc: '4排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '186',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 7,
        seatDesc: '4排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '187',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 8,
        seatDesc: '4排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '188',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 9,
        seatDesc: '4排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '189',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 5,
        seatY: 10,
        seatDesc: '4排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '190',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 1,
        seatDesc: '5排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '191',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 2,
        seatDesc: '5排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '192',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 3,
        seatDesc: '5排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '193',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 4,
        seatDesc: '5排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '194',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 5,
        seatDesc: '5排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '195',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 6,
        seatDesc: '5排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '196',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 7,
        seatDesc: '5排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '197',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 8,
        seatDesc: '5排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '198',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 9,
        seatDesc: '5排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '199',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 6,
        seatY: 10,
        seatDesc: '5排10座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '200',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 1,
        seatDesc: '6排1座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '201',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 2,
        seatDesc: '6排2座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '202',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 3,
        seatDesc: '6排3座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '203',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 4,
        seatDesc: '6排4座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '204',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 5,
        seatDesc: '6排5座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '205',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 6,
        seatDesc: '6排6座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '206',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 7,
        seatDesc: '6排7座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '207',
        status: 2,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 8,
        seatDesc: '6排8座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '208',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 9,
        seatDesc: '6排9座',
        seatType: 2,
        sectionId: '1',
        floorId: null,
        vendorSeatId: '209',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      },
      {
        seatX: 7,
        seatY: 10,
        seatDesc: '0排0座',
        seatType: 1,
        sectionId: 'null',
        floorId: null,
        vendorSeatId: '210',
        status: 1,
        vendorSeatX: null,
        vendorSeatY: null
      }
    ]
  }
};
